export default __webpack_public_path__ + "static/media/image2.801c02b1.jpg";